import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addNFCtoSecurity, getSecurityNFC} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {SecurityBase} from './type'
import {NFCCreate} from '../../../types/type'
import {useQuery} from 'react-query'
import {RunnerBall} from '../../../components/FormLoader'

function NFC({
  initialValues: securityDetails,
  onAfterSubmit,
}: {
  initialValues?: SecurityBase
  onAfterSubmit: () => void
}) {
  const {data, isFetching: isFetchingNFC} = useQuery(
    ['securityNFC', securityDetails?.security_id],
    () => getSecurityNFC(securityDetails?.security_id!),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  const submitHandler = (
    values: Omit<NFCCreate, 'type'>,
    {setSubmitting: setLoading}: FormikHelpers<any>
  ) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addNFCtoSecurity({
      id: values.id,
      type: 'security',
      nfc_code: values.nfc_code,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err: any) => {
        handleApiError(err, toastId)
      })
      .finally(() => setLoading(false))
  }
  if (isFetchingNFC) {
    return <RunnerBall />
  }
  return (
    <div className="px-5 py-3">
      <Formik<Omit<NFCCreate & {security_name: string}, 'type'>>
        initialValues={{
          id: securityDetails!.security_id,
          security_name: securityDetails!.security_name,
          nfc_code: securityDetails!.nfc_code || '',
        }}
        validationSchema={Yup.object({
          nfc_code: Yup.string()
            .trim()
            .required('RFID is required')
            .notOneOf([''], 'RFID is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              label="Bus Attendee Name"
              name="security_name"
              disabled
            />
            <FormikControl
              control="input"
              required
              placeholder="RFID"
              label="RFID"
              name="nfc_code"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default NFC
